import { TokenResponse } from '../models/TokenResponse';

export function saveAuthData(tokenResponse: TokenResponse) {
  localStorage.setItem('access_token', tokenResponse.access_token!);
  localStorage.setItem('refresh_token', tokenResponse.refresh_token!);
  localStorage.setItem('expires_in', tokenResponse.expires_in.toString()!);
  localStorage.setItem('expires_on', tokenResponse.expires_on.toString()!);
  localStorage.setItem(
    'refresh_token_expires_in',
    tokenResponse.refresh_token_expires_in.toString()!
  );
}

export function removeAuthData() {
  localStorage.removeItem('access_token');
  localStorage.removeItem('refresh_token');
  localStorage.removeItem('expires_in');
  localStorage.removeItem('expires_on');
  localStorage.removeItem('refresh_token_expires_in');
  localStorage.removeItem('stateFlow');
}

export function removeUserPreferences() {
  localStorage.removeItem('user_preferences_state');
}
